<template>
  <div>
    <b-modal v-model="showCurriculasModal" title="Programas de Formación" size="lg" hide-footer>
      <div>
        <div class="mb-3">
          <h4 class="mb-1 font-weight-bold text-primary">Programas de Formación</h4>
          <p class="text-muted mb-0">
            <i class="bi bi-info-circle mr-1"></i>
            Este usuario, en su pantalla inicial se cargan estos Programas de Formación
          </p>
        </div>
        <div class="my-2">
          <b-list-group>
            <b-list-group-item v-for="curricula in curriculasUsuario" :key="curricula.id"
              class="mb-2 p-3 shadow-sm rounded border border-light">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <span class="h5 mb-0 font-weight-bold text-dark">{{ curricula.nombre_curricula || curricula.nombre ||
                    curricula.titulo || curricula.id }}</span>
                  <b-badge variant="info" class="ml-2"
                    v-if="cursosCurriculaId === curricula.id && !cargandoCursos && cursosCurricula.length > 0">
                    {{ cursosCurricula.length }} curso{{ cursosCurricula.length === 1 ? '' : 's' }}
                  </b-badge>
                </div>
                <b-button size="sm" class="btn-studioAPP ml-2" variant="outline-warning"
                  @click="verCursos(curricula.id)">
                  <b-icon icon="book" class="mr-1"></b-icon>Ver cursos
                </b-button>
              </div>
              <transition name="fade">
                <div v-if="cursosCurricula && cursosCurriculaId === curricula.id" class="mt-2">
                  <div v-if="cargandoCursos" class="text-center text-muted py-2">
                    <b-spinner small type="grow" class="mr-2"></b-spinner> Cargando cursos...
                  </div>
                  <div v-else-if="cursosCurricula.length === 0" class="text-muted py-2">Sin cursos asignados</div>
                  <b-list-group v-else class="mb-0">
                    <b-list-group-item v-for="curso in cursosCurricula" :key="curso.id"
                      class="d-flex align-items-center border-0 px-0 py-1">
                      <b-icon v-if="curso.terminado == 1" icon="check-circle" variant="success" class="mr-2"></b-icon>
                      <b-icon v-else icon="clock" variant="warning" class="mr-2"></b-icon>
                      <span class="font-weight-normal">{{ curso.nombre_curso || curso.nombre || curso.titulo || curso.id
                        }}</span>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </transition>
            </b-list-group-item>
            <b-list-group-item v-if="curriculasUsuario.length === 0" class="text-muted">Sin Programas de Formación
              asignadas</b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </b-modal>
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="card card-block">
            <div class="card-body p-2">
              <div class="d-flex justify-content-between align-items-start p-2">
                <b-jumbotron lead="Lista usuarios"></b-jumbotron>
              </div>
              <div class="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
                <div class="d-flex gap-2 align-items-center">
                  <b-form-input v-model="search" placeholder="Buscar usuario..." @keyup.enter="buscarUsuarios"
                    @change="buscarUsuarios" class="mr-2" style="max-width:200px;" />
                  <b-form-select v-model.number="selectedRol" :options="rolesFilterOptions" @change="filtrarUsuarios"
                    class="mr-2" style="max-width:150px;" />
                  <b-form-select v-model="selectedEstatus" :options="estatusFilterOptions" @change="filtrarUsuarios"
                    style="max-width:120px;" />
                </div>
                <div>
                  <b-badge variant="primary">Total: {{ total }}</b-badge>
                </div>
              </div>
              <div class="d-flex justify-content-end mb-2">
                <b-button @click="nuevoUser" class="ml-5 btn-studioAPP" variant="outline-warning">
                  Nuevo
                </b-button>
                <b-button @click="abrirModalImportar" class="ml-2 btn-studioAPP" variant="outline-primary">
                  Importar
                </b-button>
                <b-button @click="abrirModalHistorial" class="ml-2 btn-studioAPP" variant="outline-info">
                  Historial
                </b-button>
                <b-button @click="exportarUsuarios" class="ml-2 btn-studioAPP" variant="outline-success">
                  Exportar
                </b-button>
              </div>
              <b-table class="data-table" striped hover outlined small :items="users" :fields="fields" responsive>
                <template #cell(actions)="row">
                  <div class="d-flex justify-content-around align-items-center">
                    <b-button variant="success" size="sm" @click="editUser(row.item)" v-b-tooltip.hover
                      title="Editar usuario">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path
                          d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                      </svg>
                    </b-button>
                    <b-button variant="danger" size="sm" @click="showModalEliminar(row.item)" class="ml-1"
                      v-b-tooltip.hover title="Eliminar usuario">
                      <!-- Modal eliminar usuario -->
                      <b-modal v-model="ModalEliminar" persistent title="Confirmación" size="lg" centered>
                        <b-container fluid>
                          <b-row class="m-1 text-left">
                            <b-col cols="12">
                              ¿Estás seguro de eliminar al usuario <b>"{{ userEliminar.name }}"</b> con el correo <b>{{
                                userEliminar.email }}</b> de la base de datos? Esta acción NO SE PUEDE REVERTIR
                            </b-col>
                          </b-row>
                        </b-container>
                        <template #modal-footer>
                          <div class="w-100">
                            <b-button variant="primary" size="sm" class="float-right"
                              @click="hideModalEliminar">Cancelar</b-button>
                            <b-button variant="danger" size="sm" class="float-right mx-2"
                              @click="deleteUser">Eliminar</b-button>
                          </div>
                        </template>
                      </b-modal>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash-fill" viewBox="0 0 16 16">
                        <path
                          d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                      </svg>
                    </b-button>
                    <b-button variant="info" size="sm" @click="abrirModalCurriculas(row.item)" class="ml-1"
                      v-b-tooltip.hover title="Ver Programas de Formación">
                      <b-icon icon="eye"></b-icon>
                    </b-button>
                  </div>
                </template>
                <template #cell(estatus)="{ value }">
                  <span v-if="value == 1" class="text-success">
                    <b-icon icon="check-circle-fill" variant="success"></b-icon>
                  </span>
                  <span v-else class="text-danger">
                    <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                  </span>
                </template>
              </b-table>
              <div class="d-flex justify-content-between row p-2">
                <div class="col-sm-12 col-md-6 d-flex align-items-center"></div>
                <div class="col-sm-12 col-md-6 d-flex align-items-center justify-content-end">
                  <div>
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" align="fill" size="sm"
                      class="my-0" @input="cargarUsuarios" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-modal no-close-on-backdrop centered size="lg" hide-footer no-close-on-esc hide-header-close ref="ModalUser"
        title="Usuario" v-model="ModalUser" persistent>
        <b-card tag="article" class="mb-2">
          <b-alert show variant="info" class="p-3 text-justify">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
              class="bi bi-info-circle-fill mr-2" viewBox="0 0 16 16">
              <path
                d="M8 16A8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            </svg>
            En esta sección, se pueden actualizar ciertos datos del usuario, algunos de estos datos, se actualizan
            automáticamente al momento de que el usuario accede con sus credenciales de google, por ejemplo el avatar.
          </b-alert>
          <b-card-text>
            <b-row>
              <div class="col-sm-1"></div>
              <div class="col-sm-10">
                <b-form>
                  <div class="mb-1 my-2">
                    <label for="form_user.name"> <small>Nombre</small></label>
                    <b-form-input class="my-2" ref="form_user.name" v-model="form_user.name" type="text"
                      placeholder="Nombre" />
                  </div>
                  <label for="" class="mb-2 mt-2"> <small> Roles disponibles</small></label>
                  <v-select class="my-3" placeholder="Listado completo de roles en la plataforma Aprende"
                    v-model="form_user.roles" multiple :options="item_roles">
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No resultados para <em>{{ search }}</em>.
                      </template>
                      <em v-else style="opacity: 0.5">Elegir primero.</em>
                    </template>
                  </v-select>
                  <div class="mb-2 mt-2">
                    <label for="form_user.email"> <small>Correo principal</small></label>
                    <b-form-input ref="form_user.email" class="my-2" v-model="form_user.email" type="text"
                      placeholder="Correo principal" />
                  </div>
                  <div class="mb-2 mt-2">
                    <label for="form_user.correo_alternativo"> <small>Correo Alternativo</small></label>
                    <b-form-input ref="form_user.correo_alternativo" class="my-2" v-model="form_user.correo_alternativo"
                      type="text" placeholder="Correo alternativo (opcional)" />
                  </div>
                  <div class="mb-2 mt-2">
                    <label><small>Escuelas disponibles en Aprende</small></label>
                    <v-select class="my-3" placeholder="Listado completo de escuelas en la plataforma Aprende"
                      v-model="form_user.escuela" :options="item_escuelas" />
                  </div>
                  <div class="mb-2 mt-2">
                    <label><small>Grupos</small></label>
                    <v-select class="my-3" placeholder="Listado completo de grupos en la plataforma Aprende"
                      v-model="form_user.grupos" multiple :options="gruposAprende_items" />
                  </div>
                  <b-row>
                    <b-col>
                      <label for="form_user.fecha_creacion"> <small>Fecha de creación</small></label>
                      <b-form-input ref="form_user.fecha_creacion" class="my-2" v-model="form_user.fecha_creacion"
                        type="text" disabled />
                    </b-col>
                    <b-col>
                      <label for="form_user.ultima_fecha_inicio_sesion">
                        <small>Ultimo inicio de sesión a la plataforma</small>
                      </label>
                      <b-form-input ref="form_user.ultima_fecha_inicio_sesion" class="my-2"
                        v-model="form_user.ultima_fecha_inicio_sesion" type="text" disabled />
                    </b-col>
                  </b-row>
                  <b-row class="my-2">
                    <b-col>
                      <div v-if="form_user.id > 0">
                        <label for="form_user.ultima_fecha_inicio_sesion"> <small>¿Usuario activo?</small></label>
                        <b-form-checkbox class="mt-3" v-model="form_user.estatus_user" value="1">Usuario
                          activo</b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex align-items-start justify-content-start my-1">
                    <div class="w-100">
                      <b-button variant="primary" size="sm" class="float-right"
                        @click="hiddenModalUser()">Cancelar</b-button>
                      <b-button v-if="form_user.editar === true" variant="info" size="sm" class="float-right mx-2"
                        @click="update">Actualizar registro</b-button>
                      <b-button v-if="form_user.editar === false" variant="success" size="sm" class="float-right mx-2"
                        @click="save()">Guardar</b-button>
                    </div>
                  </b-row>
                </b-form>
              </div>
              <div class="col-sm-1"></div>
            </b-row>
          </b-card-text>
        </b-card>
      </b-modal>

      <!-- Modal Importar Usuarios -->
      <b-modal v-model="showImportarModal" title="Importar usuarios por CSV" size="lg" hide-footer>
        <div>
          <b-form @submit.prevent="importarUsuarios">
            <b-form-group label="Dominio (opcional)" label-for="dominio-select">
              <v-select
                id="dominio-select"
                v-model="dominioSeleccionado"
                :options="dominiosOptions"
                :disabled="dominiosLoading"
                placeholder="Selecciona un dominio (opcional)"
                label="text"
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    No se encontraron resultados para <em>{{ search }}</em>.
                  </template>
                  <em v-else style="opacity: 0.5">Escribe para buscar.</em>
                </template>
              </v-select>
            </b-form-group>
            <b-form-group label="Grupos (opcional)" label-for="grupos-select">
              <v-select
                id="grupos-select"
                v-model="gruposSeleccionados"
                :options="gruposAprende_items"
                :reduce="grupo => grupo.value"
                label="text"
                multiple
                placeholder="Selecciona grupos (opcional)"
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    No se encontraron resultados para <em>{{ search }}</em>.
                  </template>
                  <em v-else style="opacity: 0.5">Escribe para buscar.</em>
                </template>
              </v-select>
            </b-form-group>

            <!-- Sección de Mapeo de Columnas -->
            <b-card class="mb-3" border-variant="primary">
              <template #header>
                <h6 class="mb-0">
                  <b-icon icon="table" class="mr-2"></b-icon>
                  Mapeo de Columnas del CSV
                </h6>
              </template>
              <p class="text-muted small mb-3">
                <b-icon icon="info-circle" class="mr-1"></b-icon>
                Selecciona la columna (letra) del CSV donde se encuentra cada campo
              </p>
              <b-row>
                <b-col cols="12" md="6" v-for="campo in camposCsv" :key="campo.key">
                  <b-form-group 
                    :label="campo.label" 
                    :label-for="`col-${campo.key}`"
                    class="mb-3"
                  >
                    <b-form-select
                      :id="`col-${campo.key}`"
                      v-model="columnMapping[campo.key]"
                      :options="columnasAlfabeticas"
                      :state="columnMapping[campo.key] ? true : null"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled>
                          -- Selecciona columna --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>

            <b-form-group label="Archivo CSV" label-for="archivo-csv">
              <b-form-file
                id="archivo-csv"
                v-model="archivoCsv"
                accept=".csv"
                :state="archivoCsv ? true : null"
                placeholder="Selecciona archivo CSV..."
                browse-text="Buscar"
                required
                @change="onArchivoChange"
              />
            </b-form-group>

            <!-- Checkbox para indicar si el CSV tiene encabezados -->
            <b-form-group>
              <b-form-checkbox
                id="csv-has-header"
                v-model="csvHasHeader"
                name="csv-has-header"
              >
                <span class="ml-1">
                  <b-icon icon="file-earmark-text" class="mr-1"></b-icon>
                  El archivo CSV tiene encabezados en la primera fila
                </span>
              </b-form-checkbox>
              <small class="text-muted ml-4">
                Marca esta opción si la primera fila del CSV contiene nombres de columnas (Email, Nombre, etc.)
              </small>
            </b-form-group>

            <!-- Botón para previsualizar -->
            <div class="d-flex justify-content-end mb-3" v-if="archivoCsv && !previsualizacionDatos">
              <b-button 
                variant="info" 
                @click="previsualizarDatos" 
                :disabled="cargandoPreview || !columnMapping.email"
              >
                <b-spinner small v-if="cargandoPreview" class="mr-1" />
                <b-icon icon="eye" class="mr-1" v-else></b-icon>
                Previsualizar datos
              </b-button>
            </div>

            <!-- Sección de Previsualización -->
            <b-card v-if="previsualizacionDatos" class="mb-3" border-variant="success">
              <template #header>
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">
                    <b-icon icon="eye-fill" class="mr-2"></b-icon>
                    Vista Previa de Datos
                  </h6>
                  <b-button size="sm" variant="outline-secondary" @click="limpiarPreview">
                    <b-icon icon="x"></b-icon>
                  </b-button>
                </div>
              </template>
              <p class="text-muted small mb-2">
                <b-icon icon="info-circle" class="mr-1"></b-icon>
                Mostrando {{ previsualizacionDatos.length }} de {{ totalRegistrosPreview }} registro(s)
              </p>                           

              <!-- Estadísticas de Roles -->
              <div v-if="estadisticasRoles" class="mb-3">
                <b-alert show variant="info" class="mb-0">
                  <strong><b-icon icon="people-fill" class="mr-1"></b-icon>Desglose por roles:</strong>
                  <ul class="mb-0 mt-2">
                    <li v-for="(cantidad, rol) in estadisticasRoles" :key="rol">
                      <strong>{{ rol }}:</strong> {{ cantidad }} usuario(s)
                    </li>
                    <li v-if="estadisticasRoles.sin_rol" class="text-warning">
                      <strong>Sin rol especificado:</strong> {{ estadisticasRoles.sin_rol }} usuario(s)
                      <br><small><b-icon icon="arrow-right" class="mr-1"></b-icon>Se agregarán con rol <strong>"estudiante"</strong> por defecto</small>
                    </li>
                  </ul>
                </b-alert>
              </div>

              <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                <b-table
                  striped
                  hover
                  small
                  :items="previsualizacionDatos"
                  :fields="camposPreview"
                  class="mb-0"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(email)="data">
                    <span :class="{ 'text-danger': !data.value }">
                      {{ data.value || '(vacío)' }}
                    </span>
                  </template>
                  <template #cell(nombre)="data">
                    <span :class="{ 'text-muted': !data.value }">
                      {{ data.value || '(no especificado)' }}
                    </span>
                  </template>
                  <template #cell(rol_plataforma)="data">
                    <span :class="{ 'text-muted': !data.value }">
                      {{ data.value || '(no especificado)' }}
                    </span>
                  </template>
                </b-table>
              </div>
              
              <!-- Advertencias encontradas (Todo en un solo cuadro) -->
              <div v-if="advertencias && (advertencias.emails_invalidos?.total > 0 || advertencias.dominios_no_encontrados?.total > 0 || advertencias.otras?.length > 0)" class="mt-2">
                <b-alert show variant="warning" class="mb-4">
                  <div class="w-100">
                    <!-- Título -->
                    <div class="mb-3">
                      <strong>Advertencias encontradas:</strong>
                    </div>

                    <!-- Emails Inválidos -->
                    <div v-if="advertencias.emails_invalidos && advertencias.emails_invalidos.total > 0" class="mb-4">
                      <strong>Emails Inválidos:</strong>
                      <ul class="mt-2 mb-0">
                        <li v-for="(item, idx) in advertencias.emails_invalidos.lista" :key="'email-' + idx">
                          Fila {{ item.fila }}: Formato de email inválido ({{ item.email }})
                        </li>
                      </ul>
                    </div>
                    
                    <!-- Dominios No Encontrados -->
                    <div v-if="advertencias.dominios_no_encontrados && advertencias.dominios_no_encontrados.total > 0" class="mb-4">
                      <strong>Dominios No Encontrados:</strong>
                      <ul class="mt-2 mb-2">
                        <li>
                          Se encontraron {{ advertencias.dominios_no_encontrados.total }} dominio(s) que no existen en el sistema y serán creados automáticamente
                        </li>
                      </ul>
                      <div class="mt-2">
                        <strong class="d-block mb-2">Estos dominios serán creados automáticamente:</strong>
                        <div style="max-height: 200px; overflow-y: auto;">
                          <b-list-group>
                            <b-list-group-item 
                              v-for="(dominio, idx) in advertencias.dominios_no_encontrados.lista" 
                              :key="'dom-detail-' + idx"
                              class="d-flex justify-content-between align-items-center py-2"
                            >
                              <div>
                                <span>{{ dominio.dominio }}</span>
                              </div>
                              <div>
                                <small class="text-muted">
                                  <b-icon icon="people-fill" class="mr-1"></b-icon>
                                  {{ dominio.cantidad_usuarios }} usuario(s)
                                </small>
                              </div>
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Otras Advertencias -->
                    <div v-if="advertencias.otras && advertencias.otras.length > 0" class="mb-0">
                      <strong>OTRAS:</strong>
                      <ul class="mt-2 mb-0">
                        <li v-for="(advertencia, idx) in advertencias.otras" :key="'otra-' + idx">
                          {{ advertencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </b-alert>
              </div> 
            </b-card>

            <div class="d-flex justify-content-end">
              <b-button variant="secondary" @click="showImportarModal = false">Cancelar</b-button>
              <b-button variant="primary" @click="mostrarConfirmacion" class="ml-2" :disabled="importando || !previsualizacionDatos">
                <b-spinner small v-if="importando" class="mr-1" />
                Importar
              </b-button>
            </div>
          </b-form>
        </div>
      </b-modal>

      <!-- Modal de Confirmación de Importación -->
      <b-modal v-model="showConfirmModal" title="Confirmar Importación" centered hide-footer size="lg">
        <div>
          <p class="mb-3">
            <b-icon icon="question-circle-fill" variant="warning" class="mr-2"></b-icon>
            ¿Estás seguro de que deseas importar <strong>{{ totalRegistrosPreview }}</strong> usuario(s)?
          </p>

          <!-- Advertencias Clasificadas -->
          <div v-if="advertencias">
            <!-- Emails Inválidos -->
            <b-alert v-if="advertencias.emails_invalidos && advertencias.emails_invalidos.total > 0" show variant="danger" class="mb-2">
              <strong>
                <b-icon icon="envelope-x-fill" class="mr-1"></b-icon>
                Se encontraron {{ advertencias.emails_invalidos.total }} email(s) con formato inválido
              </strong>
              <div class="mt-1">
                <small class="text-muted">Estas filas serán omitidas durante la importación</small>
              </div>
            </b-alert>

            <!-- Dominios que se crearán -->
            <b-alert v-if="advertencias.dominios_no_encontrados && advertencias.dominios_no_encontrados.total > 0" show variant="warning" class="mb-2">
              <strong>
                <b-icon icon="building-add" class="mr-1"></b-icon>
                Se crearán {{ advertencias.dominios_no_encontrados.total }} nuevo(s) dominio(s)
              </strong>
              <ul class="mb-0 mt-2">
                <li v-for="(dominio, idx) in advertencias.dominios_no_encontrados.lista" :key="'dom-modal-' + idx">
                  <small><strong>{{ dominio.dominio }}</strong> ({{ dominio.cantidad_usuarios }} usuario(s))</small>
                </li>
              </ul>
            </b-alert>

            <!-- Otras Advertencias -->
            <b-alert v-if="advertencias.otras && advertencias.otras.length > 0" show variant="info" class="mb-2">
              <ul class="mb-0">
                <li v-for="(advertencia, idx) in advertencias.otras" :key="'otra-modal-' + idx">
                  <small>{{ advertencia }}</small>
                </li>
              </ul>
            </b-alert>
          </div>
          
          <div v-if="estadisticasRoles" class="mb-3">
            <strong>Resumen por roles:</strong>
            <ul class="mt-2">
              <li v-for="(cantidad, rol) in estadisticasRoles" :key="rol">
                <strong>{{ rol }}:</strong> {{ cantidad }} usuario(s)
              </li>
            </ul>
          </div>

          <div v-if="dominioSeleccionado" class="mb-3">
            <b-alert show variant="info" class="mb-0 py-2">
              <small><b-icon icon="building" class="mr-1"></b-icon><strong>Dominio filtro:</strong> {{ dominioSeleccionado.text }}</small>
            </b-alert>
          </div>

          <div v-if="gruposSeleccionados && gruposSeleccionados.length > 0" class="mb-3">
            <b-alert show variant="info" class="mb-0 py-2">
              <small><b-icon icon="people" class="mr-1"></b-icon><strong>Grupos:</strong> {{ gruposSeleccionados.length }} grupo(s) seleccionado(s)</small>
            </b-alert>
          </div>

          <p class="text-muted small mb-3">
            <b-icon icon="exclamation-triangle" class="mr-1"></b-icon>
            Esta acción no se puede deshacer.
          </p>

          <div class="d-flex justify-content-end">
            <b-button variant="secondary" @click="showConfirmModal = false">Cancelar</b-button>
            <b-button variant="success" @click="confirmarImportacion" class="ml-2" :disabled="importando">
              <b-spinner small v-if="importando" class="mr-1" />
              Sí, importar
            </b-button>
          </div>
        </div>
      </b-modal>

      <!-- Modal Historial de Importaciones -->
      <historial-importaciones v-model="showHistorialModal" />

    </b-container>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import GestionUsuariosService from '@/services/GestionUsuariosService';
import toast from "@/mixins/ToastMixin.js";
import HistorialImportaciones from '@/components/Usuarios/HistorialImportaciones.vue';

export default {
  computed: {
    rolesFilterOptions() {
      return [
        { value: '', text: 'Todos los roles' },
        ...this.item_roles.map(r => ({ value: r.id, text: r.name || r.text || r.label }))
      ];
    }
  },
  mixins: [toast],
  components: { 
    vSelect,
    HistorialImportaciones
  },
  data() {
    return {
      showCurriculasModal: false,
      curriculasUsuario: [],
      cursosCurricula: [],
      cursosCurriculaId: null,
      cargandoCursos: false,
      curriculasUserId: null,
      showImportarModal: false,
      dominiosOptions: [],
      dominiosLoading: false,
      dominioSeleccionado: null,
      gruposSeleccionados: [],
      archivoCsv: null,
      csvHasHeader: true, // Por defecto asumimos que tiene encabezados
      importando: false,
      showHistorialModal: false,
      // Previsualización
      cargandoPreview: false,
      previsualizacionDatos: null,
      totalRegistrosPreview: 0,
      erroresPreview: [],
      estadisticasRoles: null, // Nueva propiedad para desglose de roles
      advertencias: null, // Objeto con advertencias clasificadas: { emails_invalidos: {}, dominios_no_encontrados: {}, otras: [] }
      camposPreview: [
        { key: 'index', label: '#' },
        { key: 'email', label: 'Email' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'rol_plataforma', label: 'Rol Plataforma' }
      ],
      showConfirmModal: false, // Modal de confirmación antes de importar
      // Mapeo de columnas
      columnMapping: {
        email: null,
        nombre: null,
        rol_plataforma: null
      },
      camposCsv: [
        { key: 'email', label: 'Email *', required: true },
        { key: 'nombre', label: 'Nombre (opcional)', required: false },
        { key: 'rol_plataforma', label: 'Rol Plataforma (opcional)', required: false }
      ],
      columnasAlfabeticas: [
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'C', text: 'C' },
        { value: 'D', text: 'D' },
        { value: 'E', text: 'E' },
        { value: 'F', text: 'F' },
        { value: 'G', text: 'G' },
        { value: 'H', text: 'H' },
        { value: 'I', text: 'I' },
        { value: 'J', text: 'J' },
        { value: 'K', text: 'K' },
        { value: 'L', text: 'L' },
        { value: 'M', text: 'M' },
        { value: 'N', text: 'N' },
        { value: 'O', text: 'O' },
        { value: 'P', text: 'P' },
        { value: 'Q', text: 'Q' },
        { value: 'R', text: 'R' },
        { value: 'S', text: 'S' },
        { value: 'T', text: 'T' },
        { value: 'U', text: 'U' },
        { value: 'V', text: 'V' },
        { value: 'W', text: 'W' },
        { value: 'X', text: 'X' },
        { value: 'Y', text: 'Y' },
        { value: 'Z', text: 'Z' }
      ],
      users: [],
      ModalEliminar: false,
      userEliminar: {},
      fields: [
        { key: 'id', label: 'Id' },
        { key: 'email', label: 'Email' },
        { key: 'escuela', label: 'Escuela' },
        { key: 'grupos', label: 'Grupos' },
        { key: 'roles', label: 'Rol(es)' },
        { key: 'fecha_creacion', label: 'Fecha de creación' },
        { key: 'ultima_sesion', label: 'Última fecha de inicio de sesión' },
        { key: 'estatus', label: 'Estatus' },
        { key: 'actions', label: 'Opciones', sortable: false }
      ],
      currentPage: 1,
      perPage: 10,
      total: 0,
      search: '',
      selectedRol: '',
      selectedEstatus: '',
      item_roles: [],
      estatusFilterOptions: [
        { value: '', text: 'Todos' },
        { value: 1, text: 'Activo' },
        { value: 0, text: 'Inactivo' }
      ],
      ModalUser: false,
      item_escuelas: [],
      gruposAprende_items: [],
      form_user: {
        name: '',
        email: '',
        correo_alternativo: '',
        roles: [],
        grupos: [],
        escuela: [],
        estatus_user: 0,
        id: 0,
        fecha_creacion: '',
        ultima_fecha_inicio_sesion: '',
        editar: false,
      },
      rolesOptions: [],
    }
  },
  mounted() {
    this.getEscuelas();
    this.getRoles();
    this.getGruposAprende();
    this.cargarUsuarios();
  },
  methods: {
    abrirModalHistorial() {
      this.showHistorialModal = true;
    },
    async abrirModalCurriculas(user) {
      try {
        const response = await this.$api.post('/api/usuarios/curriculas', { user_id: user.id });
        this.curriculasUsuario = response.data.curriculas || [];
        this.curriculasUserId = user.id;
        this.showCurriculasModal = true;
        this.cursosCurricula = [];
        this.cursosCurriculaId = null;
      } catch (error) {
        this.curriculasUsuario = [];
        this.curriculasUserId = null;
        this.showCurriculasModal = true;
        this.cursosCurricula = [];
        this.cursosCurriculaId = null;
        this.toast('b-toaster-bottom-center', true, 'No se pudieron cargar los Programas de Formación', 'danger');
      }
    },
    async verCursos(curriculaId) {
      this.cursosCurriculaId = curriculaId;
      this.cursosCurricula = [];
      this.cargandoCursos = true;
      try {
        // Igual que UserGestion.vue
        const response = await this.$api.get(`/api/gestion-u/curricula-user/${curriculaId}/${this.curriculasUserId}`);
        this.cursosCurricula = response.data.cursos_curricula || [];
      } catch (error) {
        this.cursosCurricula = [];
        this.toast('b-toaster-bottom-center', true, 'No se pudieron cargar los cursos', 'danger');
      } finally {
        this.cargandoCursos = false;
      }
    },
    async abrirModalImportar() {
      this.showImportarModal = true;
      this.dominioSeleccionado = null;
      this.gruposSeleccionados = [];
      this.archivoCsv = null;
      // Resetear previsualización
      this.limpiarPreview();
      // Resetear mapeo de columnas (solo email tiene valor por defecto)
      this.columnMapping = {
        email: 'A',
        nombre: null,
        rol_plataforma: null
      };
      this.dominiosOptions = [];
      this.dominiosLoading = true;
      try {
        const response = await this.$api.get('/api/gestion-u/dominios-disponibles');
        if (response.data && response.data.success && Array.isArray(response.data.data)) {
          this.dominiosOptions = response.data.data.map(d => ({ 
            value: d.domain, 
            text: `${d.nombre} (${d.domain})`,
            domain: d.domain,
            nombre: d.nombre
          }));
        } else {
          this.dominiosOptions = [];
        }
      } catch (e) {
        this.dominiosOptions = [];
        this.toast('b-toaster-bottom-center', true, 'No se pudieron cargar los dominios', 'danger');
      } finally {
        this.dominiosLoading = false;
      }
    },
    onArchivoChange() {
      // Limpiar previsualización cuando cambia el archivo
      this.limpiarPreview();
    },
    limpiarPreview() {
      this.previsualizacionDatos = null;
      this.totalRegistrosPreview = 0;
      this.erroresPreview = [];
      this.estadisticasRoles = null;
      this.advertencias = null;
      this.cargandoPreview = false;
    },
    async previsualizarDatos() {
      if (!this.archivoCsv) {
        this.toast('b-toaster-bottom-center', true, 'Selecciona un archivo CSV', 'danger');
        return;
      }
      
      if (!this.columnMapping.email) {
        this.toast('b-toaster-bottom-center', true, 'Debes seleccionar la columna de Email', 'danger');
        return;
      }
      
      this.cargandoPreview = true;
      this.limpiarPreview();
      this.cargandoPreview = true;
      
      try {
        let formData = new FormData();
        formData.append('archivo', this.archivoCsv);
        
        // Agregar dominio si está seleccionado (para filtrar previsualización)
        if (this.dominioSeleccionado && this.dominioSeleccionado.value) {
          formData.append('dominio', this.dominioSeleccionado.value);
        }
        
        // Agregar mapeo de columnas (filtrar solo las que tienen valor)
        const mappingFiltrado = Object.keys(this.columnMapping)
          .filter(key => this.columnMapping[key] !== null)
          .reduce((obj, key) => {
            obj[key] = this.columnMapping[key];
            return obj;
          }, {});
        
        formData.append('column_mapping', JSON.stringify(mappingFiltrado));
        
        // Agregar si el CSV tiene encabezados
        formData.append('has_header', this.csvHasHeader);
        
        const response = await this.$api.post('/api/gestion-u/previsualizar-csv', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        
        if (response.data.success) {
          this.previsualizacionDatos = response.data.data?.preview || response.data.preview || [];
          this.totalRegistrosPreview = response.data.data?.total || response.data.total || 0;
          this.erroresPreview = response.data.errores || [];
          this.estadisticasRoles = response.data.data?.estadisticas_roles || response.data.estadisticas_roles || null;
          this.advertencias = response.data.data?.advertencias || response.data.advertencias || null; // Nueva estructura clasificada
          
          if (this.previsualizacionDatos.length === 0) {
            this.toast('b-toaster-bottom-center', true, 'No se encontraron datos en el archivo CSV', 'warning');
          }
        } else {
          this.toast('b-toaster-bottom-center', true, response.data.message || 'Error al previsualizar', 'danger');
        }
      } catch (e) {
        console.error('Error en previsualizarDatos:', e);
        let msg = 'Error al previsualizar el archivo CSV';
        
        const errorMessage = e.message || '';
        
        // Network Error sin response generalmente es problema con el archivo (movido/modificado)
        // o problema de conexión real
        if (errorMessage.includes('Network Error') && !e.response) {
          // Si hay archivo seleccionado, probablemente fue modificado/movido
          if (this.archivoCsv) {
            msg = 'El archivo seleccionado fue modificado, movido o eliminado. Por favor, vuelve a seleccionarlo.';
            this.archivoCsv = null;
          } else {
            msg = 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.';
          }
        } else if (e.response && e.response.data && e.response.data.message) {
          msg = e.response.data.message;
        } else if (errorMessage) {
          msg = `Error: ${errorMessage}`;
        }
        
        this.toast('b-toaster-bottom-center', true, msg, 'danger');
      } finally {
        // Asegurar que siempre se desactiva el loading
        this.cargandoPreview = false;
      }
    },
    mostrarConfirmacion() {
      // Mostrar modal de confirmación antes de importar
      this.showConfirmModal = true;
    },
    async confirmarImportacion() {
      // Cerrar modal de confirmación y proceder con la importación
      this.showConfirmModal = false;
      await this.importarUsuarios();
    },
    async importarUsuarios() {
      if (!this.archivoCsv) {
        this.toast('b-toaster-bottom-center', true, 'Selecciona un archivo CSV', 'danger');
        return;
      }
      
      // Validar que solo el campo email (obligatorio) tenga una columna asignada
      if (!this.columnMapping.email) {
        this.toast('b-toaster-bottom-center', true, 'Debes seleccionar una columna para Email', 'danger');
        return;
      }
      
      this.importando = true;
      try {
        let formData = new FormData();
        formData.append('archivo', this.archivoCsv);
        
        if (this.dominioSeleccionado && this.dominioSeleccionado.value) {
          formData.append('dominio', this.dominioSeleccionado.value);
        }
        
        // Agregar grupos seleccionados
        if (this.gruposSeleccionados && this.gruposSeleccionados.length > 0) {
          formData.append('grupos', JSON.stringify(this.gruposSeleccionados));
        }
        
        // Agregar mapeo de columnas (filtrar solo las que tienen valor)
        const mappingFiltrado = Object.keys(this.columnMapping)
          .filter(key => this.columnMapping[key] !== null)
          .reduce((obj, key) => {
            obj[key] = this.columnMapping[key];
            return obj;
          }, {});
        
        formData.append('column_mapping', JSON.stringify(mappingFiltrado));
        
        // Agregar si el CSV tiene encabezados
        formData.append('has_header', this.csvHasHeader);
        
        // Agregar advertencias de previsualización para registrar en log
        if (this.advertencias && Object.keys(this.advertencias).length > 0) {
          formData.append('advertencias_preview', JSON.stringify(this.advertencias));
        }
        
        const response = await this.$api.post('/api/gestion-u/importar-masivo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        
        let color = response.data.color || 'success';
        let msg = response.data.message || 'Importación completada';
        
        // Mostrar información de escuelas creadas si existe
        if (response.data.data && response.data.data.detalles && response.data.data.detalles.escuelas_creadas && response.data.data.detalles.escuelas_creadas.length > 0) {
          const escuelas = response.data.data.detalles.escuelas_creadas;
          msg += `\n\nEscuelas creadas: ${escuelas.length}`;
          escuelas.forEach(escuela => {
            msg += `\n- ${escuela.nombre} (${escuela.domain})`;
          });
        }
        
        this.toast('b-toaster-bottom-center', true, msg, color);
        this.showImportarModal = false;
        this.cargarUsuarios();
      } catch (e) {
        console.error('Error en importarUsuarios:', e);
        let msg = 'Error al importar usuarios';
        let color = 'danger';
        
        const errorMessage = e.message || '';
        
        // Network Error sin response generalmente es problema con el archivo (movido/modificado)
        // o problema de conexión real
        if (errorMessage.includes('Network Error') && !e.response) {
          // Si hay archivo seleccionado, probablemente fue modificado/movido
          if (this.archivoCsv) {
            msg = 'El archivo seleccionado fue modificado, movido o eliminado. Por favor, vuelve a seleccionarlo.';
            this.archivoCsv = null;
          } else {
            msg = 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.';
          }
        } else if (e.response && e.response.data && e.response.data.message) {
          msg = e.response.data.message;
          color = e.response.data.color || 'danger';
        } else if (errorMessage) {
          msg = `Error: ${errorMessage}`;
        }
        
        this.toast('b-toaster-bottom-center', true, msg, color);
      } finally {
        // Asegurar que siempre se desactiva el loading
        this.importando = false;
      }
    },
    validarFormulario() {
      if (!this.form_user.name || this.form_user.name.trim() === '') {
        this.toast('b-toaster-bottom-center', true, 'El nombre es obligatorio', 'danger');
        return false;
      }
      if (!this.form_user.email || this.form_user.email.trim() === '') {
        this.toast('b-toaster-bottom-center', true, 'El correo es obligatorio', 'danger');
        return false;
      }
      if (!this.form_user.escuela || !this.form_user.escuela.id) {
        this.toast('b-toaster-bottom-center', true, 'Selecciona una escuela', 'danger');
        return false;
      }
      // Puedes agregar más validaciones aquí si lo necesitas
      return true;
    },
    async getGruposAprende() {
      const response = await this.$api.get("/api/users/GruposUsuario");
      let { gruposUsuarios } = response.data;
      this.gruposAprende_items = gruposUsuarios;
    },
    async getEscuelas() {
      try {
        const response = await this.$api.get("/api/gestion-u/escuelas");
        this.item_escuelas = response.data.resultSet;
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    async getRoles() {
      try {
        const response = await this.$api.get("/api/gestion-u/roles");
        this.item_roles = response.data.resultSet;
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    async cargarUsuarios() {
      try {
        const params = {
          page: this.currentPage,
          per_page: this.perPage,
          search: this.search,
          rol: this.selectedRol !== '' ? Number(this.selectedRol) : '',
          estatus: this.selectedEstatus
        };
        const response = await this.$api.get('/api/usuarios', { params });
        this.users = response.data.data.map(u => ({
          id: u.id || 0,
          name: u.name || u.nombre || '',
          email: u.email || '',
          correo_alternativo: u.correo_alternativo || u['correo_alternativo'] || u['Correo alternativo'] || '',
          escuela: u.escuela || '',
          grupos: u.grupos ? u.grupos.join(', ') : '',
          roles: u.roles ? u.roles.join(', ') : '',
          fecha_creacion: u.fecha_creacion || '',
          ultima_sesion: u.ultima_sesion || '',
          estatus: u.estatus || ''
        }));
        this.total = response.data.total;
        this.perPage = response.data.per_page;
        this.currentPage = response.data.current_page;
      } catch (e) {
        this.users = [];
        this.total = 0;
        this.$bvToast && this.$bvToast.toast('No se pudo cargar la lista de usuarios', { variant: 'danger' });
      }
    },
    buscarUsuarios() {
      this.currentPage = 1;
      this.cargarUsuarios();
    },
    filtrarUsuarios() {
      this.currentPage = 1;
      this.cargarUsuarios();
    },
    editUser(user) {
      // Transformar datos igual que en UserGestion.vue
      this.form_user.editar = true;
      this.form_user.id = user.id;
      // Recuperar nombre igual que en UserGestion.vue
      this.form_user.name = user.name || user.nombre || (user.full_name ? user.full_name : (user['Nombre'] || ''));
      // Recuperar correo principal
      this.form_user.email = user.email || user.correo || user['Correo'] || '';
      // Recuperar correo alternativo
      this.form_user.correo_alternativo = user.correo_alternativo || user['correo_alternativo'] || user['Correo alternativo'] || '';
      // Estatus
      this.form_user.estatus_user = user.estatus_user !== undefined ? user.estatus_user : (user.estatus || 0);
      // Fechas
      this.form_user.ultima_fecha_inicio_sesion = user.ultima_fecha_inicio_sesion || user.ultima_sesion || user['ultima_fecha_inicio_sesion'] || '';
      this.form_user.fecha_creacion = user.fecha_creacion || user.created_at || user['fecha_creacion'] || '';

      // Escuela: debe ser objeto {id, label}
      if (user.escuela && typeof user.escuela === "object" && user.escuela.id) {
        this.form_user.escuela = { id: user.escuela.id, label: user.escuela.nombre || user.escuela.label };
      } else if (user.escuela && typeof user.escuela === 'string') {
        // Buscar en item_escuelas
        const foundEscuela = this.item_escuelas.find(e => e.label === user.escuela || e.nombre === user.escuela);
        this.form_user.escuela = foundEscuela ? { id: foundEscuela.id, label: foundEscuela.label || foundEscuela.nombre } : {};
      } else {
        this.form_user.escuela = {};
      }

      // Grupos: array de objetos {id, label}
      if (user.grupos && Array.isArray(user.grupos)) {
        this.form_user.grupos = user.grupos.map(g => {
          if (typeof g === 'object' && g.id) {
            return { id: g.id, label: g.label || g.nombre_grupo };
          } else if (typeof g === 'string') {
            // Buscar en gruposAprende_items
            const foundGrupo = this.gruposAprende_items.find(item => item.label === g || item.nombre_grupo === g);
            return foundGrupo ? { id: foundGrupo.id, label: foundGrupo.label || foundGrupo.nombre_grupo } : { id: null, label: g };
          }
          return g;
        });
      } else if (user.grupos && typeof user.grupos === 'string') {
        // Si es string separado por coma
        this.form_user.grupos = user.grupos.split(',').map(g => {
          const trimmed = g.trim();
          const foundGrupo = this.gruposAprende_items.find(item => item.label === trimmed || item.nombre_grupo === trimmed);
          return foundGrupo ? { id: foundGrupo.id, label: foundGrupo.label || foundGrupo.nombre_grupo } : { id: null, label: trimmed };
        });
      } else {
        this.form_user.grupos = [];
      }

      // Roles: array de objetos {id, label}
      if (user.roles && Array.isArray(user.roles)) {
        this.form_user.roles = user.roles.map(r => {
          if (typeof r === 'object' && r.id) {
            return { id: r.id, label: r.label || r.name };
          } else if (typeof r === 'string') {
            // Buscar en item_roles
            const foundRol = this.item_roles.find(item => item.label === r || item.name === r);
            return foundRol ? { id: foundRol.id, label: foundRol.label || foundRol.name } : { id: null, label: r };
          }
          return r;
        });
      } else if (user.roles && typeof user.roles === 'string') {
        // Si es string separado por coma
        this.form_user.roles = user.roles.split(',').map(r => {
          const trimmed = r.trim();
          const foundRol = this.item_roles.find(item => item.label === trimmed || item.name === trimmed);
          return foundRol ? { id: foundRol.id, label: foundRol.label || foundRol.name } : { id: null, label: trimmed };
        });
      } else {
        this.form_user.roles = [];
      }

      this.showModalUser();
    },
    showModalEliminar(user) {
      this.userEliminar = user;
      this.ModalEliminar = true;
    },
    hideModalEliminar() {
      this.ModalEliminar = false;
      this.userEliminar = {};
    },
    async deleteUser() {
      try {
        const response = await GestionUsuariosService.delete(this.userEliminar.id);
        let { success, message, color } = response.data;
        if (success) {
          this.ModalEliminar = false;
          this.userEliminar = {};
          this.cargarUsuarios();
        }
        this.toast('b-toaster-bottom-center', true, message, color);
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    nuevoUser() {
      this.resetForm();
      this.showModalUser();
    },
    resetForm() {
      this.form_user = {
        name: '',
        email: '',
        correo_alternativo: '',
        roles: [],
        grupos: [],
        escuela: [],
        estatus_user: 0,
        id: 0,
        fecha_creacion: '',
        ultima_fecha_inicio_sesion: '',
        editar: false,
      };
    },
    showModalUser() {
      this.ModalUser = true;
    },
    hiddenModalUser() {
      this.ModalUser = false;
      this.resetForm();
    },
    async save() {
      if (!this.validarFormulario()) return;
      try {
        let formData = new FormData();
        formData.append("name", this.form_user.name);
        formData.append("email", this.form_user.email);
        formData.append("correo_alternativo", this.form_user.correo_alternativo);
        formData.append("escuela", this.form_user.escuela.id);
        let arrGrupos = [];
        this.form_user.grupos.forEach(el => { arrGrupos.push(el.id); });
        formData.append("arrGrupos", arrGrupos);
        let arrRoles = [];
        this.form_user.roles.forEach(el => { arrRoles.push(el.id); });
        formData.append("arrRoles", arrRoles);
        const response = await GestionUsuariosService.save(formData);
        let { success, message, color } = response.data;
        if (success) {
          this.ModalUser = false;
          this.cargarUsuarios();
        }
        this.toast('b-toaster-bottom-center', true, message, color);
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    async update() {
      if (!this.validarFormulario()) return;
      try {
        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("id", this.form_user.id);
        formData.append("name", this.form_user.name);
        formData.append("email", this.form_user.email);
        formData.append("correo_alternativo", this.form_user.correo_alternativo);
        formData.append("estatus_user", this.form_user.estatus_user ? 1 : 0);
        formData.append("escuela", this.form_user.escuela.id);
        let arrGrupos = [];
        this.form_user.grupos.forEach(el => { arrGrupos.push(el.id); });
        formData.append("arrGrupos", arrGrupos);
        let arrRoles = [];
        this.form_user.roles.forEach(el => { arrRoles.push(el.id); });
        formData.append("arrRoles", arrRoles);
        const response = await GestionUsuariosService.update(this.form_user.id, formData);
        let { success, message, color } = response.data;
        if (success) {
          this.ModalUser = false;
          this.cargarUsuarios();
        }
        this.toast('b-toaster-bottom-center', true, message, color);
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    async exportarUsuarios() {
      try {
        const params = {
          search: this.search,
          rol: this.selectedRol,
          estatus: this.selectedEstatus,
        };
        const response = await this.$api.get('/api/usuarios/export', {
          params,
          responseType: 'blob',
          headers: { 'Accept': 'text/csv' },
        });
        if (!response.data || response.data.size === 0) throw new Error('Sin archivos');
        const blob = new Blob([response.data], { type: 'text/csv' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        // Obtener el nombre del archivo del header Content-Disposition
        let filename = 'usuarios.csv';
        let disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']);
        // Axios a veces no expone los headers correctamente con blobs, intentar obtenerlo del request si es posible
        if (!disposition && response.request && response.request.getResponseHeader) {
          disposition = response.request.getResponseHeader('content-disposition');
        }
        if (disposition && disposition.indexOf('filename=') !== -1) {
          filename = disposition.split('filename=')[1].replace(/['";]/g, '').trim();
        }
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (e) {
        this.toast('b-toaster-bottom-center', true, e.message || 'No se pudo exportar la lista', 'danger');
      }
    }
  }
}
</script>
